'use client'

import { Link } from '@/components/ui/link'
import { SeoLink } from '@/lib/generated/graphql-types'
import { getSalaryUrl } from '@/modules/salary/filters/get-salary-filters-from-url'
import { SalaryFilterParam } from '@/modules/salary/constants'
import { pluralize } from '@/utils/strings'
import { useSalaryFilters } from '@/modules/salary/filters/use-salary-filters'
import { handleSeoLinkClick } from '@/modules/salary/salary-seo-links/utils'
import { SALARY_FULL_TIME_VALUE } from '@/modules/surveys/configs/onboarding/current-job-pane-config'

export function SeoBreadcrumb({
  link,
  disableLink,
  isAuthenticated,
}: {
  link: SeoLink | { name: string; url: string }
  disableLink?: boolean
  isAuthenticated: boolean
}) {
  const { updateSalaryFilters, salaryFilterControls } = useSalaryFilters({
    isAuthenticated,
  })
  if ('name' in link) {
    return (
      <Link href={link.url} className="text-xs">
        {link.name}
      </Link>
    )
  }
  const enableLinkOverride =
    salaryFilterControls?.jobType !== SALARY_FULL_TIME_VALUE ||
    salaryFilterControls?.state
  if (disableLink && !enableLinkOverride) {
    return (
      <span className="text-xs text-copy-accent">
        {link.occupation?.baseTitlePlusSpecialty ||
          pluralize(link.profession?.name ?? '')}
      </span>
    )
  }
  const url = getSalaryUrl({
    filtersParams: {
      [SalaryFilterParam.occupation]:
        link.occupation?.slug ?? link.profession?.slug,
      [SalaryFilterParam.jobType]: link.jobType,
      [SalaryFilterParam.location]: link.state?.slug,
    },
  })
  const handleClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    handleSeoLinkClick({ evt, link, updateSalaryFilters })
  }
  if (link.profession) {
    return (
      <Link href={url} className="text-xs" onClick={handleClick}>
        {pluralize(link.profession.name)}
      </Link>
    )
  }
  return (
    <Link
      href={url}
      className="text-xs"
      onClick={handleClick}
      data-testid="seo-breadcrumb"
    >
      {link.occupation?.baseTitlePlusSpecialty}
    </Link>
  )
}
